const API = process.env.REACT_APP_API_URL || '';

let accessToken = null;
let refreshInFlight = null;

async function readBody(res) {
  const text = await res.text();
  if (!text) return {};
  try {
    return JSON.parse(text);
  } catch {
    return {};
  }
}

async function refreshOnce(attempt) {
  let res;
  try {
    res = await fetch(`${API}/api/auth/refresh`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'X-Requested-With': 'jotty' },
    });
  } catch {
    return { error: 'network' };
  }
  const body = await readBody(res);
  if (res.status === 401 && body.error === 'refresh_race' && attempt < 1) {
    await new Promise((resolve) => setTimeout(resolve, 250));
    return refreshOnce(attempt + 1);
  }
  if (!res.ok || !body.accessToken) {
    accessToken = null;
    return null;
  }
  accessToken = body.accessToken;
  return body;
}

export function refreshSession() {
  if (!refreshInFlight) {
    refreshInFlight = refreshOnce(0).finally(() => {
      refreshInFlight = null;
    });
  }
  return refreshInFlight;
}

export async function api(path, options = {}) {
  const headers = {
    'X-Requested-With': 'jotty',
    ...(options.body ? { 'Content-Type': 'application/json' } : {}),
    ...(options.headers || {}),
  };
  if (!options.skipAuth && accessToken) headers.Authorization = `Bearer ${accessToken}`;

  let res;
  try {
    res = await fetch(`${API}${path}`, {
      method: options.method || 'GET',
      headers,
      body: options.body,
      credentials: 'include',
    });
  } catch {
    return { ok: false, status: 0, body: { error: 'network' } };
  }

  if (res.status === 401 && !options.skipAuth && !options.retried) {
    const session = await refreshSession();
    if (session?.accessToken) return api(path, { ...options, retried: true });
  }

  const body = await readBody(res);
  return { ok: res.ok, status: res.status, body };
}

export async function login(email, password) {
  const result = await api('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
    skipAuth: true,
  });
  if (result.ok) accessToken = result.body.accessToken;
  return result;
}

export async function register(email, password, name) {
  const result = await api('/api/auth/register', {
    method: 'POST',
    body: JSON.stringify({ email, password, name }),
    skipAuth: true,
  });
  if (result.ok) accessToken = result.body.accessToken;
  return result;
}

export async function logoutRequest() {
  const result = await api('/api/auth/logout', { method: 'POST', skipAuth: true });
  accessToken = null;
  return result;
}

export function updateProfile(name) {
  return api('/api/auth/me', {
    method: 'PATCH',
    body: JSON.stringify({ name }),
  });
}
